import { post } from '@/lib/api.js';

const inFlightDeliveries = new Map();
const DELIVERY_REQUEST_TIMEOUT_MS = 6_500;

const deliverGravityWebsiteHandoff = ({ handoffId } = {}) => {
  if (inFlightDeliveries.has(handoffId)) {
    return inFlightDeliveries.get(handoffId);
  }

  const request = new Promise((resolve) => {
    let settled = false;
    const settle = (result) => {
      if (settled) {
        return;
      }

      settled = true;
      window.clearTimeout(timeoutId);
      resolve(result);
    };
    const timeoutId = window.setTimeout(() => {
      settle({
        success: false,
        code: 'GRAVITY_WEBSITE_HANDOFF_DELIVERY_TIMEOUT'
      });
    }, DELIVERY_REQUEST_TIMEOUT_MS);

    try {
      post(`v1/gravity/website-handoffs/${encodeURIComponent(handoffId)}/deliver`, {
        data: {},
        callback: (data, error) => {
          if (!error && typeof data?.delivered === 'boolean' && typeof data?.alreadyDelivered === 'boolean') {
            settle({
              success: true,
              data
            });
            return;
          }

          settle(error || data);
        }
      });
    } catch {
      settle({
        success: false,
        code: 'GRAVITY_WEBSITE_HANDOFF_DELIVERY_FAILED'
      });
    }
  });
  const trackedRequest = request.finally(() => {
    inFlightDeliveries.delete(handoffId);
  });

  inFlightDeliveries.set(handoffId, trackedRequest);
  return trackedRequest;
};

export default deliverGravityWebsiteHandoff;
